import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ISyncCoreApi } from '@edgebox/sync-core-rest-client';
import React from 'react';
import { loadHealthCheckReferenceDataByKey } from './HealthCheckReferenceData';
import { resolveHealthCheckScorePresentation } from './HealthCheckScorePresentation';

function normalizeScore(score: number): number {
  return Math.max(0, Math.min(1, score));
}

export function HealthCheckCriticalityBadge({
  api,
  healthCheckKey,
  score,
}: {
  api?: ISyncCoreApi;
  healthCheckKey?: string;
  score?: number;
}) {
  const [presentation, setPresentation] = React.useState<ReturnType<typeof resolveHealthCheckScorePresentation> | undefined>(undefined);

  React.useEffect(() => {
    if (!healthCheckKey || typeof score !== 'number') {
      setPresentation(undefined);
      return;
    }

    let active = true;

    void (async () => {
      const referenceData = await loadHealthCheckReferenceDataByKey(api, healthCheckKey);
      if (!active) {
        return;
      }

      const weightedScore = normalizeScore(score) / referenceData.defaultScoreWeight;
      const weightedPercentage = Math.round(normalizeScore(weightedScore) * 100);
      setPresentation(resolveHealthCheckScorePresentation(weightedPercentage));
    })();

    return () => {
      active = false;
    };
  }, [api, healthCheckKey, score]);

  if (!presentation) {
    return null;
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold" style={presentation.style}>
      <FontAwesomeIcon icon={faWarning} className="text-[0.625rem]" /> {presentation.label}
    </span>
  );
}
